/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Table, Drawer } from 'antd';
import { CloseOutlined, CaretRightFilled, SwapOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import BatchSelector from '@Components/Inventory/Indent/CreateIndent/BatchSelector';
import H3FormInput from '@Uilib/h3FormInput';

import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '@Uilib/h3Image';
import OfferActions from '@Actions/offerActions';
import './style.scss';
import { QUANTITY } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import SelectProductSeller from '@Components/Common/SelectProductSeller';

const FulfillmentLines = ({
  selectedLocationFulfillment, loading, data, toggleBatch, toggleBatchInner, allStock, toggleAllStock, updateData, formSubmitted, MONEY, soMapping, handleDelete, setIsSellerChange, isMarketplaceEnabled,
}) => {
  const [openSwapSellerDrawer, setOpenSwapSellerDrawer] = useState(false);
  const [tenantProductId, setTenantProductId] = useState('');
  const [currentKey, setCurrentKey] = useState('');

  function getBundleLineKeys(rows) {
    const keys = [];
    for (let i = 0; i < rows?.length; i++) {
      if (rows[i]?.bundle_products?.length) {
        keys.push(rows[i]?.key);
      }
    }
    return keys;
  }

  const fulfillmentLinesColumns = () => {
    const columns = [
      {
        title: 'PRODUCT',
        width: '220px',
        render: (item) => ({
          props: { style: { backgroundColor: (isMarketplaceEnabled && !item?.seller_id) ? '#ABE09835' : 'white' } },
          children: (
            <Fragment>
              {item?.sellerId ? (
                <Fragment>
                  <div className="uff-table__location-wrapper">
                    <div className="uff-table__fg-name">
                      {item?.sellerName?.toProperCase()}
                      {' '}
                      <CaretRightFilled />
                    </div>
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <Link to={`/inventory/product/view/${item?.product_sku_info?.product_sku_id}`} target="_blank">
                    {item?.product_sku_info?.internal_sku_code}
                  </Link>
                  <div>
                    {`${item?.product_sku_info?.ref_product_code ? `${item?.product_sku_info?.ref_product_code} - ` : ''} ${item?.product_sku_info?.product_sku_name}`?.trim()}
                  </div>
                  <H3Text text={item.remarks} className="quotation__remarks" />
                </Fragment>
              )}
            </Fragment>
          ),
        }),
        onCell: (item) => {
          if (isMarketplaceEnabled && !item?.seller_id) {
            return { colSpan: 9 };
          }
          return {};
        },
      },
      {
        title: 'AVAILABLE STOCK',
        width: '120px',
        render: (text, record) => {
          let availableQty = 0;
          const bundleProducts = record?.bundle_products?.filter((item) => !['NON_STORABLE', 'SERVICE'].includes(item?.product_sku_info?.product_type));
          if (bundleProducts?.length) {
            const arr = [];
            for (let i = 0; i < bundleProducts?.length; i++) {
              const qty = Helpers.getValueTotalInObject(bundleProducts?.[i]?.product_batches?.filter((i) => i?.available_qty > 0)?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
              arr.push(qty / (bundleProducts[i]?.so_quantity / Number(record?.so_quantity || 1)));
            }
            availableQty = Math.min(...arr);
          } else {
            availableQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((i) => i?.available_qty > 0)?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
          }

          return (
            <Fragment>
              { ['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && '-'}
              {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && record?.product_sku_name
                        && (
                          <Fragment>
                            {availableQty ? `${QUANTITY((availableQty / record?.uom_info?.ratio) * record?.product_sku_info?.uom_info?.ratio, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}` : <span style={{ color: 'red', fontSize: '11px', whiteSpace: 'nowrap' }}>OUT OF STOCK</span>}
                          </Fragment>
                        )}
              { !['SERVICE', 'BUNDLE'].includes(record?.product_sku_info?.product_type?.toUpperCase()) && availableQty ? (
                <H3Text
                  text={`In ${record?.product_batches?.filter((i) => i?.available_qty > 0)?.filter((item) => item?.batch_in_use)?.length || '0'} Batches`}
                  className="table-subscript"
                />
              ) : ''}
            </Fragment>
          );
        },
        onCell: (item) => {
          if (isMarketplaceEnabled && !item?.seller_id) {
            return { colSpan: 0 };
          }
          return {};
        },
      },
      {
        title: 'ORDERED QTY',
        render: (text, record) => `${QUANTITY(record?.fulfillable_quantity || '0', record?.product_sku_info?.uom_info?.precision)} ${record?.product_sku_info?.uom_info?.uqc?.toProperCase() || ''}`,
        onCell: (item) => {
          if (isMarketplaceEnabled && !item?.seller_id) {
            return { colSpan: 0 };
          }
          return {};
        },
      },
      {
        title: 'QUANTITY',
        dataIndex: 'quantity',
        width: '120px',
        render: (text, record) => {
          let availableQty = 0;
          const bundleProducts = record?.bundle_products?.filter((item) => !['NON_STORABLE', 'SERVICE'].includes(item?.product_sku_info?.product_type));
          if (bundleProducts?.length) {
            const arr = [];
            for (let i = 0; i < bundleProducts?.length; i++) {
              const qty = Helpers.getValueTotalInObject(bundleProducts?.[i]?.product_batches?.filter((i) => i?.available_qty > 0)?.filter((item) => item?.batch_in_use), 'available_qty');
              arr.push(qty / (bundleProducts[i]?.so_quantity / record?.so_quantity));
            }
            availableQty = Math.min(...arr);
          } else {
            availableQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((i) => i?.available_qty > 0)?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
          }
          return (
            <div>
              <div className="inv-qty-input">
                {!record?.parent_line_id && (
                  <H3FormInput
                    value={record.quantity}
                    type="number"
                    containerClassName={`orgInputContainer ${(formSubmitted && Number(record.quantity) <= 0) ? 'create-pr__input' : ''}`}
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput"
                    onWheel={(event) => event.target.blur()}
                    onChange={(event) => {
                      const copyData = JSON.parse(JSON.stringify(data));
                      if (record?.bundle_products?.length) {
                        // const bundleProducts = JSON.parse(JSON.stringify(record?.bundle_products));
                        for (let i = 0; i < bundleProducts?.length; i++) {
                          const bundleProductBatches = !allStock ? bundleProducts[i]?.product_batches?.filter((i) => i?.available_qty > 0) : bundleProducts[i]?.product_batches?.filter((i) => i?.available_qty > 0)?.filter((productBatch) => !productBatch?.is_rejected_batch);

                          for (let j = 0; j < bundleProductBatches?.length; j++) {
                            bundleProductBatches[j].consumed_qty = 0;
                          }
                          let remainingQty = parseFloat(event.target.value) * bundleProducts[i]?.bundle_quantity;
                          for (let j = 0; j < bundleProductBatches?.length; j++) {
                            const avlQty = ((bundleProductBatches?.[j]?.available_qty / bundleProducts[i]?.uom_info?.ratio) * bundleProducts[i]?.product_sku_info?.uom_info?.ratio);

                            if (bundleProductBatches[j]?.batch_in_use) {
                              if (remainingQty > 0 && parseFloat((bundleProductBatches[j].consumed_qty)) < avlQty) {
                                bundleProductBatches[j].consumed_qty = (avlQty > remainingQty ? remainingQty : avlQty);
                                remainingQty -= bundleProductBatches[j].consumed_qty;
                              } else {
                                bundleProductBatches[j].consumed_qty = 0;
                                remainingQty -= bundleProductBatches[j].consumed_qty;
                              }
                            }
                          }
                          // bundleProducts[i].product_batches = bundleProductBatches;
                          const updatedData = copyData.map((obj) => {
                            if (obj.key === record.key) {
                              return { ...obj, quantity: event.target.value, bundle_products: bundleProducts };
                            }
                            return obj;
                          });
                          updateData(updatedData);
                        }
                      } else {
                        const batches = record?.product_batches;
                        let remainingQty = parseFloat(event.target.value);
                        for (let i = 0; i < batches?.length; i++) {
                          batches[i].consumed_qty = 0;
                        }
                        for (let i = 0; i < batches?.length; i++) {
                          const avlQty = (batches?.[i]?.available_qty / record?.uom_info?.ratio) * record?.product_sku_info?.uom_info?.ratio;
                          if (batches[i]?.batch_in_use && (allStock ? !batches[i]?.is_rejected_batch : true)) {
                            if (remainingQty > 0 && parseFloat(batches[i].consumed_qty || '0') < avlQty) {
                              batches[i].consumed_qty = avlQty > remainingQty ? remainingQty : avlQty;
                              remainingQty -= batches[i].consumed_qty;
                            } else {
                              batches[i].consumed_qty = 0;
                              remainingQty -= batches[i].consumed_qty;
                            }
                          }
                        }
                        const updatedData = copyData.map((obj) => {
                          if (obj.key === record.key) {
                            return { ...obj, quantity: event.target.value, product_batches: batches };
                          }
                          return obj;
                        });
                        updateData(updatedData);
                      }
                    }}
                    disabled={['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type?.toUpperCase()) ? false : !availableQty}
                  />
                )}
                <div className="inv-qty-input-uom">{record?.uom_info?.uqc?.toProperCase()}</div>
              </div>
              {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type)
                  && ((Number(availableQty - record?.quantity) < 0 || availableQty === 0))
                ? (
                  <div className="input-error">
                    *Entered quantity is more than available quantity
                  </div>
                ) : (
                  <Fragment>
                    {['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && formSubmitted
                    && Number(availableQty + record?.quantity < 0)
                      ? (
                        <div className="input-error">
                          Sufficient inventory is not available.
                        </div>
                      ) : ''}
                  </Fragment>
                )}
            </div>
          );
        },
        onCell: (item) => {
          if (isMarketplaceEnabled && !item?.seller_id) {
            return { colSpan: 0 };
          }
          return {};
        },
      },
      {
        title: 'PRICE',
        render: (record) => (
          <React.Fragment>
            {MONEY(soMapping?.[`${record?.product_sku_info?.product_sku_id}`]?.[0]?.unit_price)}
          </React.Fragment>
        ),
        onCell: (item) => {
          if (isMarketplaceEnabled && !item?.seller_id) {
            return { colSpan: 0 };
          }
          return {};
        },
      },
      {
        title: 'TAX',
        render: (record) => (
          <Fragment>
            {`${soMapping?.[`${record?.product_sku_info?.product_sku_id}`]?.[0]?.tax_info?.tax_value }%`}
          </Fragment>
        ),
        onCell: (item) => {
          if (isMarketplaceEnabled && !item?.seller_id) {
            return { colSpan: 0 };
          }
          return {};
        },
      },
      {
        title: 'LINE TOTAL',
        render: (text, record) => {
          const unitPrice = soMapping?.[`${record?.product_sku_info?.product_sku_id}`]?.[0]?.unit_price;
          const taxValue = soMapping?.[`${record?.product_sku_info?.product_sku_id}`]?.[0]?.tax_info?.tax_value;
          return (
            <H3Text text={(record.quantity && (taxValue) >= 0) ? MONEY((record.quantity * unitPrice * (1 + (taxValue) / 100) * (record.discount ? Number(100 - record.discount) / 100 : 1))) : '0'} />
          );
        },
        onCell: (item) => {
          if (isMarketplaceEnabled && !item?.seller_id) {
            return { colSpan: 0 };
          }
          return {};
        },
      },
      {
        title: '',
        width: '40px',
        render: (text, record) => (
          <Fragment>
            {data.length !== record.key && (
              <div className="update-invoice__delete-line-button" onClick={() => handleDelete(record.key)}>
                <CloseOutlined />
              </div>
            )}
          </Fragment>
        ),
        onCell: (item) => {
          if (isMarketplaceEnabled && !item?.seller_id) {
            return { colSpan: 0 };
          }
          return {};
        },
      },
    ];

    if (isMarketplaceEnabled) {
      columns.splice(7, 0, {
        title: 'SELLER',
        render: (text, record) => (
          <Fragment>
            {record?.seller_id !== 'others' ? (
              <div
                className="swap-seller__action-button"
                onClick={() => {
                  setOpenSwapSellerDrawer(true);
                  setTenantProductId(record?.tenant_product_id);
                  setCurrentKey(record?.key);
                }}
              >
                <div style={{ marginRight: '5px' }}><SwapOutlined /></div>
                <div>Swap Seller</div>
              </div>
            ) : '-'}
          </Fragment>
        ),
        onCell: (item) => {
          if (isMarketplaceEnabled && !item?.seller_id) {
            return { colSpan: 0 };
          }
          return {};
        },
      });
    }

    return columns;
  };

  const bundleProductListColumns = [
    {
      title: 'PRODUCT',
      width: '200px',
      render: (text, record) => (
        <div className="invoice-table__product-name">
          <Link to={`/inventory/product/view/${record?.tenant_product_info?.product_sku_info?.product_sku_id}`} target="_blank">
            {record?.tenant_product_info?.product_sku_info?.product_sku_name}
          </Link>
        </div>
      ),
    },
    {
      title: 'AVAILABLE STOCK',
      width: '120px',
      render: (text, record) => {
        const availableQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((i) => i?.available_qty > 0)?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
        return (
          <Fragment>
            { ['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && '-'}
            {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && record?.product_sku_name
                      && (
                        <Fragment>
                          {availableQty ? `${QUANTITY((availableQty / record?.uom_info?.ratio) * record?.product_sku_info?.uom_info?.ratio, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}` : <span style={{ color: 'red', fontSize: '11px', whiteSpace: 'nowrap' }}>OUT OF STOCK</span>}
                        </Fragment>
                      )}
            {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'available_qty') ? (
              <H3Text
                text={`In ${record?.product_batches?.filter((i) => i?.available_qty > 0)?.filter((item) => item?.batch_in_use)?.length || '0'} Batches`}
                className="table-subscript"
              />
            ) : ''}
          </Fragment>
        );
      },
    },
    {
      title: 'ORDERED QTY',
      width: '120px',
      render: (text, record) => `${QUANTITY(record?.so_quantity || '0', record?.tenant_product_info?.product_sku_info?.uom_info?.precision)} ${record?.tenant_product_info?.product_sku_info?.uom_info?.uqc?.toProperCase() || ''}`,
    },
    {
      title: 'FULFILL QUANTITY',
      dataIndex: 'quantity',
      width: '120px',
      render: (text, record) => (
        <div>{`${Helpers.getValueTotalInObject(record?.product_batches, 'consumed_qty')} ${record?.tenant_product_info?.product_sku_info?.uom_info?.uqc?.toProperCase()}`}</div>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="pr-table-wrapper hide__in-mobile">
        <Table
          bordered
          loading={loading}
          showHeader
          size="small"
          columns={fulfillmentLinesColumns()}
          dataSource={data}
          pagination={false}
          expandable={{
            rowExpandable: (record) => (!['NON_STORABLE', 'SERVICE'].includes(record?.product_sku_info?.product_type?.toUpperCase())) && record.product_sku_name && (!record?.bundle_products?.length ? Helpers.getValueTotalInObject(record?.product_batches?.filter((i) => i?.available_qty > 0), 'available_qty') : true),
            defaultExpandedRowKeys: getBundleLineKeys(data),
            expandedRowRender: (record) => (
              <Fragment>
                {record?.bundle_products?.length ? (
                  <div className="inv__bundle-products__wrapper">
                    <Table
                      bordered
                      loading={loading}
                      showHeader
                      size="large"
                      columns={bundleProductListColumns}
                      dataSource={record.bundle_products}
                      pagination={false}
                      expandable={{
                        defaultExpandAllRows: false,
                        rowExpandable: (innerRecord) => innerRecord.product_sku_name && Helpers.getValueTotalInObject(innerRecord?.product_batches, 'available_qty'),
                        expandedRowRender: (innerRecord) => (
                          <BatchSelector
                            allStock={allStock}
                            upDateAllStock={() => {
                              const copyData = JSON.parse(JSON.stringify(data));
                              const filteredData = copyData?.map((item) => {
                                if (record.key === item.key) {
                                  for (let i = 0; i < item.product_batches?.length; i++) {
                                    item.product_batches[i].consumed_qty = 0;
                                  }
                                  item.quantity = 0;
                                }
                                return {
                                  ...item,
                                };
                              });
                              updateData(filteredData);
                              toggleAllStock();
                            }}
                            batches={innerRecord?.product_batches?.filter((i) => i?.available_qty > 0)}
                            uomInfo={innerRecord?.uom_info}
                            productUomInfo={innerRecord?.product_sku_info?.uom_info}
                            expiryDays={innerRecord?.product_sku_info?.expiry_days}
                            itemsRow={innerRecord}
                            onToggleBatch={(batch, adjustmentRow) => toggleBatchInner(batch, adjustmentRow)}
                          />
                        ),
                      }}
                      scroll={{ x: 'max-content' }}
                    />
                  </div>
                ) : (
                  <BatchSelector
                    allStock={allStock}
                    upDateAllStock={() => {
                      const copyData = JSON.parse(JSON.stringify(data));
                      const filteredData = copyData?.map((item) => {
                        if (record.key === item.key) {
                          for (let i = 0; i < item.product_batches?.length; i++) {
                            item.product_batches[i].consumed_qty = 0;
                          }
                          item.quantity = 0;
                        }
                        return {
                          ...item,
                        };
                      });
                      updateData(filteredData);
                      toggleAllStock();
                    }}
                    batches={record?.product_batches?.filter((i) => i?.available_qty > 0)}
                    uomInfo={record?.uom_info}
                    productUomInfo={record?.product_sku_info?.uom_info}
                    expiryDays={record?.product_sku_info?.expiry_days}
                    itemsRow={record}
                    onToggleBatch={(batch, adjustmentRow) => toggleBatch(batch, adjustmentRow)}
                  />
                )}
              </Fragment>
            ),
          }}
        />
      </div>
      <Drawer
        visible={openSwapSellerDrawer}
        onClose={() => setOpenSwapSellerDrawer(false)}
        width="400px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '355px' }}>
            <H3Text text="Select Seller" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenSwapSellerDrawer(false)} />
          </div>
        </div>
        <SelectProductSeller
          hideTitle
          tenantProductId={tenantProductId}
          onClose={() => {
            setOpenSwapSellerDrawer(false);
            setIsSellerChange(true);
          }}
          containerClass="orgInputContainer "
          inputClassName="create-offer__input-row__input"
          labelClassName="orgFormLabel"
          setIsSellerChange={setIsSellerChange}
          updateData={updateData}
          currentKey={currentKey}
          data={data}
        />
      </Drawer>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({

});

FulfillmentLines.propTypes = {
  user: PropTypes.any,
  selectedLocationFulfillment: PropTypes.any,
  soMapping: PropTypes.any,
  data: PropTypes.any,
  handleDelete: PropTypes.func,
  updateData: PropTypes.func,
  toggleBatch: PropTypes.any,
  allStock: PropTypes.any,
  toggleAllStock: PropTypes.func,
  setIsSellerChange: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FulfillmentLines));
